import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Button, Divider, Form, Input, Label, Popup } from "semantic-ui-react";


import { getTranslate } from "react-localize-redux/lib/index";
import { getDimensions, getProductGroups } from "../../../../../reducer";
import { loadDimensions, loadProductGroups } from "../../../../../reducer/actions";

const requiredAttributes = {
    alkohol: ["Rotweine", "Weissweine", "Roséweine", "Schaumweine", "Portweine", "Spirituosen", "Bier"],
    empfehlung: ["Rotweine", "Weissweine", "Roséweine", "Schaumweine", "Portweine", "Spirituosen", "Bier"],
    gewichting: [],
    bestelleinheit: [],
    region: [],
    lagerfaehigkeit: ["Rotweine", "Weissweine", "Roséweine", "Schaumweine"],
    barrique: ["Rotweine", "Weissweine", "Roséweine", "Schaumweine"],
    schwere: ["Rotweine", "Weissweine", "Roséweine", "Schaumweine"],
    traubensorte: ["Rotweine", "Weissweine", "Roséweine", "Schaumweine"],
    herkunftsbezeichnung: ["Rotweine", "Weissweine", "Roséweine", "Schaumweine"],
    jahrgang: ["Rotweine", "Weissweine", "Roséweine"],
    holzkiste: ["Rotweine", "Weissweine", "Roséweine", "Schaumweine"],
};

const specialAttributes = ["schwere", "lagerfaehigkeit", "holzkiste", "barrique", "jahrgang", "bestelleinheit", "alkohol"];

class Attributes extends Component {


    constructor(props) {
        super(props);
        this.state = {
            product: props.product,
            vintageOptions: []
        };


    }

    componentDidMount() {
        this.props.loadProductGroups()
            .then(() => {
                this.setAttributesAsOld()
                    .then(() => {
                        this.addMissingAttributes();
                    });
            });
        this.props.loadDimensions()
            .then(() => {
                this.setState({
                    vintageOptions: Object.values(this.props.dimensions)
                        .reduce((a, b) => {
                            if (b.name === "Jahrgang") {
                                return b.variations.map((v) => {
                                    return {
                                        key: v.code,
                                        text: v.code,
                                        value: v.code
                                    };
                                });
                            }
                            return a;
                        }, [])
                });
            });
    }

    setAttributesAsOld() {

        return new Promise((resolve) => {
            let attributes = this.state.product.product_attributes;
            for (let key in attributes) {
                attributes[key].old = true;
            }

            this.setState({
                product: {
                    ...this.state.product,
                    product_attributes: attributes
                }
            }, () => {
                resolve();
            });

        });

    }

    addMissingAttributes() {

        let attributes = this.state.product.product_attributes;

        const group_id = this.state.product.group_id;
        const groupName = this.props.productGroups.reduce((a, b) => {
            if (b.id === group_id) {
                return b.name;
            }
            return a;
        }, null);


        const requiredAttributesKeys = Object.keys(requiredAttributes);
        let foundRequiredAttributes = [];

        for (let key in attributes) {

            const attributeName = attributes[key].name;

            if (requiredAttributesKeys.indexOf(attributeName) < 0) {
                if (this.state.product.requestType === "newVintage") {
                    this.deleteAttributeByName(attributeName);
                }
                continue;
            }

            foundRequiredAttributes.push(attributes[key].name);

        }

        for (let key in requiredAttributes) {
            if (foundRequiredAttributes.includes(key)) {
                continue;
            }

            if (requiredAttributes[key].length !== 0 && !requiredAttributes[key].includes(groupName)) {
                continue;
            }

            this.setAttribute(key, "");

        }

    }

    isRequired(name) {

        if (!Object.keys(requiredAttributes)
            .includes(name)) {
            return false;
        }

        const group_id = this.state.product.group_id;
        const groupName = this.props.productGroups.reduce((a, b) => {
            if (b.id === group_id) {
                return b.name;
            }
            return a;
        }, null);

        return !(requiredAttributes[name].length !== 0 && !requiredAttributes[name].includes(groupName));

    }

    getAttributeByName(name) {
        return this.state.product.product_attributes.reduce((a, b, key) => {
            if (b.name === name) {
                b.key = key;
                return b;
            }
            return a;
        }, null);
    }


    deleteAttributeByName(name) {

        if (this.state.product.requestType === "edit") {
            let product_attributes = this.state.product.product_attributes || [];
            let attribute = this.getAttributeByName(name);

            if (attribute !== null && attribute.old && attribute.old === true) {
                attribute.delete = true;
                attribute.value = "undefined";
                product_attributes[attribute.key] = attribute;
                return this.setState(({ product }) => ({
                    product: {
                        ...product,
                        product_attributes
                    }
                }));
            }
        }

        this.setState({
            product: {
                ...this.state.product,
                product_attributes: this.state.product.product_attributes.filter((attribute) => name !== attribute.name)
            }
        });
    }

    validate() {
        for (let key in this.state.product.product_attributes) {
            if (!this.state.product.product_attributes[key].value) {
                return false;
            }
        }
        return true;
    }

    setAttribute(name, value) {

        let product_attributes = this.state.product.product_attributes || [];
        let attribute = this.getAttributeByName(name);

        if (attribute !== null) {
            attribute.value = value;
            product_attributes[attribute.key] = attribute;
        } else {
            product_attributes.unshift({
                name,
                value
            });
        }

        this.setState(({ product }) => ({
            product: {
                ...product,
                product_attributes
            }
        }));
    }

    changeAttributeName(key, name) {
        if (!!this.getAttributeByName(name)) {
            return;
        }
        this.setState(({ product }) => ({
            product: {
                ...product,
                product_attributes: product.product_attributes.map((attribute, mapKey) => {
                    if (key === mapKey) {
                        return {
                            name,
                            value: attribute.value
                        };
                    }
                    return attribute;
                })
            }
        }));
    }


    render() {

        const { translate } = this.props;

        return <Form>
            {
                !this.state.product.product_attributes &&
                <div>
                    <Divider horizontal>Attribute</Divider>
                    <br/>
                    <Button
                        fluid
                        type={"button"}
                        primary
                        icon={"plus"}
                        onClick={(e) => {
                            e.preventDefault();
                            this.setAttribute("newAttribute", "");
                        }}>Add new Attribute</Button>
                </div>
            }
            {
                this.state.product.product_attributes &&
                <div>

                    <Divider horizontal>Spezielle Attribute</Divider>

                    {this.isRequired("jahrgang") &&

                    <Form.Dropdown
                        value={this.getAttributeByName("jahrgang") && this.getAttributeByName("jahrgang").value}
                        error={!this.getAttributeByName("jahrgang")}
                        fluid
                        label={translate("tools.fields.vintage")}
                        selection
                        search
                        options={this.state.vintageOptions}
                        onChange={(e, { value }) => {
                            this.setAttribute("jahrgang", value);
                        }}
                    />
                    }
                    {this.isRequired("schwere") &&
                    <div>
                        <Form.Dropdown
                            value={this.getAttributeByName("schwere") && this.getAttributeByName("schwere").value}
                            fluid
                            error={!this.getAttributeByName("schwere")}
                            label={translate("tools.fields.richness")}
                            selection
                            search
                            options={[{
                                key: "leicht",
                                text: translate("tools.fields.richnessOptions.light"),
                                value: "leicht"
                            }, {
                                key: "mittel",
                                text: translate("tools.fields.richnessOptions.medium"),
                                value: "mittel"
                            }, {
                                key: "schwer",
                                text: translate("tools.fields.richnessOptions.heavy"),
                                value: "schwer"
                            }]}
                            onChange={(e, { value }) => {
                                this.setAttribute("schwere", value);
                            }}
                        />
                    </div>}
                    {this.isRequired("lagerfaehigkeit") &&
                    <div>
                        <Form.Dropdown
                            value={this.getAttributeByName("lagerfaehigkeit") && this.getAttributeByName("lagerfaehigkeit").value}
                            fluid
                            error={!this.getAttributeByName("lagerfaehigkeit")}
                            label={translate("tools.fields.storability")}
                            selection
                            search
                            options={[{
                                key: "kurz",
                                text: translate("tools.fields.storabilityOptions.short"),
                                value: "kurz"
                            }, {
                                key: "mittel",
                                text: translate("tools.fields.storabilityOptions.medium"),
                                value: "mittel"
                            }, {
                                key: "lang",
                                text: translate("tools.fields.storabilityOptions.long"),
                                value: "lang"
                            }]}
                            onChange={(e, { value }) => {
                                this.setAttribute("lagerfaehigkeit", value);
                            }}
                        />
                    </div>}
                    {this.isRequired("barrique") &&
                    <div>
                        <Form.Dropdown
                            value={this.getAttributeByName("barrique") && this.getAttributeByName("barrique").value}
                            fluid
                            label={translate("tools.fields.barrique")}
                            error={!this.getAttributeByName("barrique")}
                            selection
                            search
                            options={[{
                                key: "Ja",
                                text: translate("general.yes"),
                                value: "Ja"
                            }, {
                                key: "Nein",
                                text: translate("general.no"),
                                value: "Nein"
                            }]}
                            onChange={(e, { value }) => {
                                this.setAttribute("barrique", value);
                            }}
                        />
                    </div>}
                    {this.isRequired("holzkiste") &&
                    <div>
                        <Form.Dropdown
                            value={this.getAttributeByName("holzkiste") && this.getAttributeByName("holzkiste").value}
                            fluid
                            label={translate("tools.fields.box")}
                            error={!this.getAttributeByName("holzkiste")}
                            selection
                            search
                            options={[{
                                key: "Ja",
                                text: translate("general.yes"),
                                value: "Ja"
                            }, {
                                key: "Nein",
                                text: translate("general.no"),
                                value: "Nein"
                            }]}
                            onChange={(e, { value }) => {
                                this.setAttribute("holzkiste", value);
                            }}
                        />
                    </div>}

                    <Popup trigger={
                        <Form.Field label={translate("tools.fields.orderUnit")} control='input'
                                    type='number' min={1}
                                    step={1}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        this.setAttribute("bestelleinheit", value);
                                    }}
                                    error={!this.getAttributeByName("bestelleinheit") || !Number.isInteger(Number.parseInt(this.getAttributeByName("bestelleinheit").value, 10))}
                                    value={this.getAttributeByName("bestelleinheit") && this.getAttributeByName("bestelleinheit").value}
                        />
                    }
                           on='focus'
                           header={translate("tools.fields.orderUnit")}
                           content='Die Artikelbezeichnung sollte wie vom Leiferanten vorgegeben übernommen werden. Falls der Artikel jedoch keinen EAN aufweist, sollte die Bezeichnung evtl. angepasst werden, so dass der Artikel eindeutig und ohne Verwechslungsgefahr im System und an der Kasse gefunden werden kann.'
                    />

                    {this.isRequired("alkohol") &&
                    <Form.Field label={translate("tools.fields.alcohol")} control='input'
                                type='number' min={0} max={100} step={0.01}
                                error={!this.getAttributeByName("alkohol")}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    this.setAttribute("alkohol", value);
                                }}
                                value={this.getAttributeByName("alkohol") && this.getAttributeByName("alkohol").value}
                    />
                    }


                    <Divider horizontal>Attribute</Divider>
                    <br/>
                    <Button
                        fluid
                        primary
                        type={"button"}
                        onClick={(e) => {
                            e.preventDefault();
                            this.setAttribute("newAttribute", "");
                        }}>Neues Attribut hinzufügen</Button>
                    {this.state.product.product_attributes.filter((attribute) => {
                        return !specialAttributes.includes(attribute.name) && !attribute.delete;
                    })
                        .map((attribute, key) =>
                            <div key={key}>

                                <Form.Input
                                    value={attribute.value}
                                    fluid
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        this.setAttribute(attribute.name, value);
                                    }}
                                    error={!attribute.value}
                                >
                                    {
                                        <Label><Input
                                            value={attribute.name}
                                            onChange={(e) => {
                                                if (Object.keys(requiredAttributes)
                                                    .includes(attribute.name)) {
                                                    return;
                                                }
                                                const name = e.target.value;
                                                this.changeAttributeName(key, name);
                                            }}
                                        /></Label>
                                    }
                                    <input/>
                                    {!Object.keys(requiredAttributes)
                                        .includes(attribute.name) &&
                                    <Button onClick={(e) => {
                                        e.preventDefault();
                                        this.deleteAttributeByName(attribute.name);
                                    }}>Remove</Button>
                                    }
                                </Form.Input>
                            </div>
                        )}
                    {this.validate() &&
                    <Button fluid positive onClick={() => {
                        if (this.validate() === true) {
                            this.props.onComplete(this.state.product);
                        }
                    }}>Next</Button>
                    }
                </div>
            }
        </Form>;
    }


}

Attributes.propTypes = {
    onComplete: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    productGroups: getProductGroups(state.tools),
    dimensions: getDimensions(state.tools),

});


const mapDispatchToProps = (dispatch) => {
    return ({
        loadProductGroups: () => (dispatch(loadProductGroups())),
        loadDimensions: () => (dispatch(loadDimensions())),

    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Attributes);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/Attributes/index.js